import { render, staticRenderFns } from "./reward.vue?vue&type=template&id=4a410b6b&scoped=true&"
import script from "./reward.vue?vue&type=script&lang=ts&"
export * from "./reward.vue?vue&type=script&lang=ts&"
import style0 from "./reward.vue?vue&type=style&index=0&id=4a410b6b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a410b6b",
  null
  
)

export default component.exports